import { combineReducers } from 'redux';
import {
studioAppConfig
} from './draftsReducer';

const rootReducer = combineReducers({
  studioAppConfig
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.ts